import React, { useEffect, useState } from "react";
import { OrderStatus } from "../../../../../../Interfaces/formValue-interfaces";
import styles from "./orderStatusDialog.module.scss";
import useLanguagesHooks from "../../../../../../Components/Languages/setLanguage-hooks";
import { ButtonTypes, OrderTypes } from "../../../../../../Interfaces/componentTypes";
import { useUpdateOrderStatusMutation } from "../../../../../../API/authApi";
import Button from "../../../../../../Components/Button/button";
import { useToastify } from "../../../../../../Hooks/hooks";

export interface IOrderStatusDialog {
    order_id: string;
    company_id: number;
    current_status: OrderStatus;
    orderType: OrderTypes;
    onClose: () => void;
    setLocalStatus?: React.Dispatch<React.SetStateAction<OrderStatus>>
}

const OrderStatusDialog: React.FC<IOrderStatusDialog> = ({
    order_id,
    company_id,
    current_status,
    orderType,
    onClose,
    setLocalStatus
}) => {
    const { t } = useLanguagesHooks();
    const [selectedStatus, setSelectedStatus] = useState<OrderStatus | null>(null);
    const { showToastSuccess, showToastError } = useToastify();
    const [updateOrderStatus, { isLoading, isSuccess, isError }] = useUpdateOrderStatusMutation();

    // Filter statuses based on rules
    const getAvailableStatuses = () => {
        let baseStatuses: OrderStatus[] = [
            OrderStatus.ACCEPTED,
            OrderStatus.IN_PREPARATION,
            OrderStatus.OUT_FOR_DELIVERY,
            OrderStatus.READY_FOR_PICKUP,
            OrderStatus.REJECTED,
            OrderStatus.CANCELLED,
            OrderStatus.DELIVERED,
        ];

        if (orderType === OrderTypes.DELIVERY) {
            baseStatuses = baseStatuses.filter(
                (status) => status !== OrderStatus.READY_FOR_PICKUP
            );
        }

        if (orderType === OrderTypes.PREORDER) {
            baseStatuses = baseStatuses.filter(
                (status) =>
                    status !== OrderStatus.OUT_FOR_DELIVERY
            );
        }

        return baseStatuses;
    };

    const availableStatuses = getAvailableStatuses();

    const handleConfirm = async () => {
        if (!selectedStatus) return;
        updateOrderStatus({
            order_id,
            body: { company_id, status: selectedStatus },
        })
    };

    useEffect(() => {
        if (isSuccess && selectedStatus) {
            showToastSuccess(t('Toast.Success.Common'));
            setLocalStatus && setLocalStatus(selectedStatus)
            onClose();
        } else if (isError) {
            showToastError(t('Toast.Error.Common'))
        }
    }, [isSuccess, isError]);

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <p>{t(`My_Business.OrderStatus.Dialog.Header`)}</p>
            </div>

            <div className={styles.statusList}>
                {availableStatuses.map((status) => (
                    <div className={styles.statusBox}>
                        <div
                            key={status}
                            className={`${current_status === status ?
                                styles.currentStatusBadge : styles.statusBadge} ${styles[`status-${status}`]} ${selectedStatus === status ? styles.selected : ""
                                }`}
                            onClick={() => setSelectedStatus(status)}
                        >
                            <span>{t(`My_Business.OrderStatus.${status}`)}</span>
                        </div>
                        <div className={styles.statusCurrnet}>
                            {status === current_status && (
                                <p className={styles.currentStatus}>{t('Visitor.Current')}</p>
                            )}
                            {selectedStatus === status && status !== current_status && (
                                <p className={styles.checkedtStatus}>
                                    {t(`My_Business.OrderStatus.Selected`)}
                                </p>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            <div className={styles.buttonBox}>
                <Button
                    buttonType={!selectedStatus ? ButtonTypes.Disabled : ButtonTypes.Primery}
                    onClick={handleConfirm}
                    title={t('Buttons.Confirm')}
                    disable={!selectedStatus || isLoading}
                />
            </div>
        </div>
    );
};

export default OrderStatusDialog;
